import React , { useEffect , useState }from 'react'

import MoveTable from './MoveTheTable'
import MoveTheTableRep from './MoveTheTableRep'
import MoveScroller from './MoveScroller'
import MoveButton from './MoveButton'
//import UploadDataSpinner from '../'
import UploadDataSpinner from '../UploadDataSpinner'

import { ApiCallGet } from '../ApiCall/ApiCall'
import MoveTheTable from './MoveTheTable'

function Indexado() {

const [response,setResponse] = useState( null )
const [count,setCount] = useState( 0 )
const [showUpload,setShowUpload] = useState( false )  

function onClicked(){
  setShowUpload( true )
  ApiCallGet("moveprod")
  .then((response) =>{
    //console.log( "Nos esta llegando la respuesta" , response )
    alert("Datos movidos a produccion")
    setShowUpload( false )
  })
  .catch((error) => {
    console.log(error)
    setShowUpload( false )
    alert("Error al mover los datos a produccion")
  })

}

function onNewPos( obj ) {
    console.log( "obj.first = " + obj.first )
    console.log( "obj.len = " + obj.len )

    ApiCallGet( 'downfiletmp?first=' + obj.first +"&len=" + obj.len)
    .then( (response) => {
        console.log( "Nos esta llegando la respuesta")
        //console.log(  )
        setResponse( response.rows )
        setCount( response.count )
        return ;
    } )
    .catch( (error) => {
        console.log( error )
    })
}

useEffect(() => {
    //backMonitor()
    ApiCallGet( 'downfiletmp?first=' + 1 +"&len=" + 10)
    .then( (response) => {
        console.log( "Nos esta llegando la respuesta")
        //console.log(  )
        setResponse( response.rows )
        setCount( response.count )
        return ;
    } )
    .catch( (error) => {
        console.log( error )
    })
},[])

  return (
    <div>
        <MoveTheTable data={response}/>
        <MoveScroller count={count} setNewPos={(val) => onNewPos( val)}/>
        <MoveButton  clicked={()=>onClicked()} count={count}/>
        {showUpload && (
            <>
                
                <UploadDataSpinner/>

            </>
        ) }
    </div>
  )
}

export default Indexado